import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import {DataSource} from '@angular/cdk/collections';
import {MatPaginator, MatSort} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/switchMap';

import { UserModel } from './../../models';
import { UserService, EventsService } from './../../services';

@Component({
    selector: 'app-users',
    templateUrl: './app-users.component.html',
    styleUrls: ['./app-users.component.scss']
})
export class AppUsersComponent {    

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('filter') filter: ElementRef;  

    displayedColumns = ['username', 'displayname', 'buttons'];

    usersdataSource: UsersDataSource | null;

    users: UserModel[];

    constructor(private userService: UserService,
                private eventsService: EventsService) {        
        
    }

    ngOnInit() {
        this.usersdataSource = new UsersDataSource(this.userService, this.paginator, this.sort);        
        Observable.fromEvent(this.filter.nativeElement, 'keyup')
            .debounceTime(150)
            .distinctUntilChanged()
            .subscribe(() => {
            if (!this.usersdataSource) { return; }
            this.usersdataSource.filter = this.filter.nativeElement.value;
            });

        this.refresh();
    }

    add() {
        this.eventsService.addUser();
    }

    edit(row: UserModel) {        
        this.eventsService.addUser(row.id);
    }

    refresh() {
        this.eventsService.refreshUsersEmitter.subscribe(() => {
            this.usersdataSource.filter = this.filter.nativeElement.value;
        })
    }
}

export class UsersDataSource extends DataSource<any> {
    _filterChange = new BehaviorSubject('');
    get filter(): string { return this._filterChange.value; }
    set filter(filter: string) { this._filterChange.next(filter); }
  
    filteredData: UserModel[] = [];
    renderedData: UserModel[] = [];    

    constructor(private userService: UserService,
                private _paginator: MatPaginator,
                private _sort: MatSort) {
      super();
  
      // Reset to the first page when the user changes the filter.
      this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
    }
  
    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<UserModel[]> {
        // Listen for any changes in the base data, sorting, filtering, or pagination
        const displayDataChanges = [
            this._sort.sortChange,
            this._filterChange,
            this._paginator.page,
        ];      

        return Observable.merge(...displayDataChanges)        
            
        .switchMap(() => {
            return this.userService.getUser()
                .map((res) => {
                // Filter data
                this.filteredData = res.slice().filter((item: UserModel) => {
                    let searchStr = (item.displayname + item.username).toLowerCase();
                    return searchStr.indexOf(this.filter.toLowerCase()) != -1;
                });
                // Sort filtered data
                const sortedData = this.sortData(this.filteredData.slice());                

                // Grab the page's slice of the filtered sorted data.
                const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
                this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize); 
                            
                return this.renderedData;
            });
        })
    }
  
    disconnect() {}
  
    /** Returns a sorted copy of the database data. */
    sortData(data: UserModel[]): UserModel[] {
      if (!this._sort.active || this._sort.direction == '') { return data; }
  
      return data.sort((a, b) => {
        let propertyA: number|string = '';
        let propertyB: number|string = '';
  
        switch (this._sort.active) {
          case 'displayname': [propertyA, propertyB] = [a.displayname, b.displayname]; break;
          case 'username': [propertyA, propertyB] = [a.username, b.username]; break;
        }
  
        let valueA = isNaN(+propertyA) ? propertyA : +propertyA;
        let valueB = isNaN(+propertyB) ? propertyB : +propertyB;
  
        return (valueA < valueB ? -1 : 1) * (this._sort.direction == 'asc' ? 1 : -1);
      });
    }
  }


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/components/app-users/app-users.component.ts